import { Link, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2";
import logo from "../../logo.png";

const HeaderOne = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const [scroll, setScroll] = useState(false);
  const [isMenuActive, setIsMenuActive] = useState(false);
  const mobileMenuRef = useRef(null);

  useEffect(() => {
    // Initialize Select2 when component mounts
    import("select2").then(() => {
      const selectElement = $(".js-example-basic-single");
      if (selectElement.length > 0) {
        selectElement.select2();
      }
    });

    const handleScroll = () => {
      setScroll(window.pageYOffset > 150);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuActive(!isMenuActive);
    document.body.classList.toggle("scroll-hide-sm", !isMenuActive);
  };

  const closeMenu = () => {
    setIsMenuActive(false);
    document.body.classList.remove("scroll-hide-sm");
  };

  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close menu when viewport becomes desktop
  useEffect(() => {
    if (windowWidth >= 992 && isMenuActive) closeMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowWidth]);

  // Close menu on route change
  useEffect(() => {
    if (isMenuActive) closeMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  // Click outside & Esc to close (only while open)
  useEffect(() => {
    if (!isMenuActive) return;

    const handleOutside = (e) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(e.target)) {
        closeMenu();
      }
    };

    const handleEsc = (e) => {
      if (e.key === "Escape") closeMenu();
    };

    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("keydown", handleEsc);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMenuActive]);

  const handleSubmenuClick = (index) => {
    if (windowWidth < 992) {
      setActiveSubmenu((prevIndex) => (prevIndex === index ? null : index));
    }
  };

  const menuItems = [
    { href: "/", label: "Home" },
    {
      label: "About",
      links: [
        { href: "/about-us", label: "Overview" },
        { href: "/vision-mission", label: "Vision and Mission" },
        { href: "/facilities", label: "Facilities" },
        { href: "/leadership", label: "Leadership" },
        { href: "/average-school-day", label: "Average School Day" },
        // { href: "/school-details", label: "School Details" },
      ],
    },
    {
      label: "Program",
      links: [
        { href: "/scholastic-program", label: "Scholastic Program" },
        { href: "/co-scholastic-program", label: "Co-Scholastic Program" },
      ],
    },
    { href: "/admission", label: "Admission" },
    { href: "/gallery", label: "Gallery" },
    {
      href: "/mandatory-public-disclosure",
      label: "Mandatory Public Disclosure",
    },
    { href: "/activities", label: "Activities" },
    { href: "/contact", label: "Contact" },
  ];

  return (
    <>
      <div
        className={`side-overlay ${isMenuActive ? "show" : ""}`}
        onClick={closeMenu}
        aria-hidden="true"
      />

      <header className={`header ${scroll ? "fixed-header" : ""}`}>
        <div className="container container--xl">
          <nav className="header-inner flex-between gap-8">
            <div className="header-content-wrapper flex-align flex-grow-1">
              {/* Logo */}
              <div className="logo">
                <Link to="/" className="link" onClick={closeMenu}>
                  <img src={logo} alt="Logo" />
                </Link>
              </div>

              {/* Desktop Menu */}
              <div className="header-menu d-lg-block d-none">
                <ul className="nav-menu flex-align">
                  {menuItems.map((item, index) =>
                    item.links ? (
                      <li key={index} className="nav-menu__item has-submenu">
                        <span className="nav-menu__link">{item.label}</span>
                        <ul className="nav-submenu scroll-sm">
                          {item.links.map((link, linkIndex) => (
                            <li
                              key={linkIndex}
                              className={`nav-submenu__item ${pathname === link.href ? "activePage" : ""
                                }`}
                            >
                              <Link
                                to={link.href}
                                className="nav-submenu__link hover-bg-neutral-30"
                              >
                                {link.label}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ) : (
                      <li
                        key={index}
                        className={`nav-menu__item ${pathname === item.href ? "activePage" : ""
                          }`}
                      >
                        <Link to={item.href} className="nav-menu__link">
                          {item.label}
                        </Link>
                      </li>
                    )
                  )}
                </ul>
              </div>
            </div>

            {/* Header Right */}
            <div className="header-right flex-align">
              <Link
                to="https://npskudluacadamis.com/online-application/nps-kudlu"
                target="_blank"
                className="btn d-lg-block d-none btn-outline-main rounded-pill flex-align gap-6"
              >
                Apply Online
              </Link>

              <Link
                to="https://npskudluacadamis.com/online-application/nps-kudlu"
                target="_blank"
                className="info-action w-52 h-52 bg-main-25 hover-bg-main-600 border border-neutral-30 rounded-circle flex-center text-2xl text-neutral-500 hover-text-white hover-border-main-600"
                onClick={closeMenu}
              >
                <i className="ph ph-user-circle" />
              </Link>

              <button
                type="button"
                className="toggle-mobileMenu d-lg-none text-neutral-200 flex-center"
                onClick={toggleMenu}
                aria-expanded={isMenuActive}
                aria-controls="mobileMenu"
                aria-label="Toggle menu"
              >
                <i className="ph ph-list" />
              </button>
            </div>
          </nav>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        id="mobileMenu"
        className={`mobile-menu scroll-sm d-lg-none d-block ${isMenuActive ? "active" : ""
          }`}
        ref={mobileMenuRef}
        role="dialog"
        aria-modal="true"
      >
        <button
          type="button"
          className="close-button"
          onClick={closeMenu}
          aria-label="Close menu"
        >
          <i className="ph ph-x" />
        </button>
        <div className="mobile-menu__inner">
          <Link to="/" className="mobile-menu__logo" onClick={closeMenu}>
            <img src={logo} alt="Logo" />
          </Link>

          <div className="mobile-menu__menu">
            <ul className="nav-menu flex-align nav-menu--mobile">
              {menuItems.map((item, index) =>
                item.links ? (
                  <li
                    key={index}
                    className={`nav-menu__item has-submenu ${activeSubmenu === index ? "activePage" : ""
                      }`}
                    onClick={() => handleSubmenuClick(index)}
                  >
                    <span className="nav-menu__link">{item.label}</span>
                    <ul className="nav-submenu scroll-sm">
                      {item.links.map((link, linkIndex) => (
                        <li key={linkIndex} className="nav-submenu__item">
                          <Link
                            to={link.href}
                            className="nav-submenu__link hover-bg-neutral-30"
                            onClick={closeMenu}
                          >
                            {link.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                ) : (
                  <li
                    key={index}
                    className={`nav-menu__item ${pathname === item.href ? "activePage" : ""
                      }`}
                  >
                    <Link
                      to={item.href}
                      className="nav-menu__link"
                      onClick={closeMenu}
                    >
                      {item.label}
                    </Link>
                  </li>
                )
              )}
            </ul>

            <div className="d-sm-none d-block mt-24">
              <div className="header-select border border-neutral-30 bg-main-25 rounded-pill position-relative">
                <span className="select-icon position-absolute top-50 translate-middle-y inset-inline-start-0 z-1 ms-lg-4 ms-12 text-xl pointer-event-none d-flex">
                  <i className="ph-bold ph-squares-four" />
                </span>
                <Link
                  to="/admission"
                  className="btn d-lg-block d-none btn-outline-main rounded-pill flex-align gap-6"
                  onClick={closeMenu}
                >
                  Apply Online
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderOne;
